/* eslint-disable react/no-danger */
import React, { useState } from 'react';
import _ from 'lodash';
import { AnimatePresence, motion } from 'framer-motion';
import { Link } from 'gatsby';

import BoxedContainer from './layouts/BoxedContainer';
import Sprites from '../components/Sprites';

function Card({ data, index }) {
  const titleString = _.get(data, 'content.titleString', '');
  const textString = _.get(data, 'content.textString', '');
  const icon = _.get(data, 'content.icon', '');

  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.3 * (index + 1) }}
      className="col-span-12 md:col-span-6 lg:col-span-4">
      <div
        className="flex flex-col items-start gap-6 relative
      px-5 lg:px-7.5 pt-10 lg:pb-10 lg:pt-15 pb-7 border-t-2 border-red bg-white h-full">
        <Sprites
          name={icon}
          className="h-13.5 w-fit lg:h-20 absolute top-0 left-1/2 transform -translate-x-1/2
        -translate-y-1/2 child:stroke-red"
        />
        <div className="w-full flex justify-between items-center">
          <div
            className="text-clamp14to20 ltr:font-LibreBaskervilleRegular 
        rtl:font-GESSTwoDWTCMedium  text-carbonGrey leading-1.4">
            {titleString}
          </div>
        </div>
        <motion.div
          key={index}
          initial="collapsed"
          animate="open"
          exit="collapsed"
          variants={{
            open: { opacity: 1, height: 'auto' },
            collapsed: { opacity: 0, height: 0 },
          }}
          transition={{ duration: 0.3 }}
          className="grid grid-cols-1 gap-4 lg:gap-5 overflow-hidden">
          <p
            className="text-[#4A4A4A] ltr:font-URWDINRegular 
            rtl:font-GESSTwoDWTCLight m-0 leading-1.5">
            {textString}
          </p>
        </motion.div>
      </div>
    </motion.div>
  );
}

function Cardsm({ data, index, expandedIndex, setExpandedIndex }) {
  const titleString = _.get(data, 'content.titleString', '');
  const textString = _.get(data, 'content.textString', '');
  const icon = _.get(data, 'content.icon', '');
  const handleToggle = () => {
    if (expandedIndex === index) {
      // If the same card is clicked, close it
      setExpandedIndex(null);
    } else {
      // Otherwise, toggle the clicked card
      setExpandedIndex(index);
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.3 * (index + 1) }}
      className="relative col-span-1">
      <div
        className="flex flex-col items-start gap-6 pt-10 lg:pb-10 lg:pt-15 pb-7 
        border-t-2 border-red bg-white md:hidden">
        <Sprites
          name={icon}
          className="h-13.5 w-fit lg:h-20 absolute top-0 left-1/2 transform -translate-x-1/2
        -translate-y-1/2 child:stroke-red"
        />
        <div className="w-full flex flex-col justify-end lg:justify-between items-center relative">
          <div
            className="text-clamp14to20 ltr:font-LibreBaskervilleRegular 
        rtl:font-GESSTwoDWTCMedium  text-carbonGrey absolute -top-2 left-5 right-5">
            {titleString}
          </div>
          <button
            type="button"
            onClick={handleToggle}
            className="relative flex justify-end lg:hidden w-full
                  pt-10 px-5 pb-5
                  -mt-10 -mb-5">
            {expandedIndex === index ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="7"
                viewBox="0 0 12 7"
                fill="none">
                <path
                  d="M11 6L6 1L1 6"
                  stroke="#58595B"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            ) : (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="7"
                viewBox="0 0 12 7"
                fill="none">
                <path
                  d="M1 1L6 6L11 1"
                  stroke="#58595B"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            )}
          </button>
        </div>
        <AnimatePresence>
          {expandedIndex === index && (
            <motion.div
              key={index}
              initial="collapsed"
              animate="open"
              exit="collapsed"
              variants={{
                open: { opacity: 1, height: 'auto' },
                collapsed: { opacity: 0, height: 0 },
              }}
              transition={{ duration: 0.3 }}
              className="grid grid-cols-1 gap-4 lg:gap-5 overflow-hidden px-5">
              <p
                className="text-[#4A4A4A] ltr:font-URWDINRegular rtl:font-GESSTwoDWTCLight 
            m-0 leading-1.5 pt-5">
                {textString}
              </p>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </motion.div>
  );
}

function FreeZoneHubServices({ id, data }) {
  const [toggle, setToggle] = useState(0);
  const [expandedIndex, setExpandedIndex] = useState(0);
  const hubServiceCards = _.get(data, 'hubServiceCards', []);

  return (
    <section id={id} className="pt-[50px] md:pt-20 pb-12 md:pb-[100px] bg-[#f7f7f7] md:bg-porcelain">
      <BoxedContainer className="lg:max-w-[1168px] px-6 xl:px-0 flex flex-col gap-[50px] md:gap-[70px]">
        <div className="grid grid-cols-12 lg:gap-20">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: 0.4 }}
            viewport={{ once: true }}
            className="col-span-12 flex flex-col items-center gap-5">
            <div
              className="child:text-clamp20to40 child:ltr:!font-URWDINMedium 
              child:rtl:!font-GESSTwoDWTCMedium child:leading-[1.3]
              last:child:!m-0 *:child:text-center child:text-[#231F20]"
              dangerouslySetInnerHTML={{ __html: _.get(data, 'title', '') }}
            />
            <div className="py-px bg-red w-10 lg:w-12.5" />
            <div
              className="child:text-clamp12to18 child:ltr:!font-URWDINRegular 
              child:rtl:!font-GESSTwoDWTCLight child:leading-1.4
              last:child:!m-0 child:text-center col-span-6 child:text-[#4A4A4A]"
              dangerouslySetInnerHTML={{ __html: _.get(data, 'text', '') }}
            />
          </motion.div>
        </div>
        <div
          className="hidden md:grid grid-cols-12
            md:gap-x-6 md:gap-y-12 lg:gap-8 lg:gap-y-14 xl:gap-10 xl:gap-y-16 ">
          {hubServiceCards.map((item, index) => (
            <Card key={index} index={index} data={item} toggle={toggle} setToggle={setToggle} />
          ))}
        </div>
        <div
          className="grid
            gap-11.75 lg:gap-6 lg:gap-y-16 md:hidden">
          {hubServiceCards.map((item, index) => (
            <Cardsm
              key={index}
              index={index}
              data={item}
              expandedIndex={expandedIndex}
              setExpandedIndex={setExpandedIndex}
            />
          ))}
        </div>
      </BoxedContainer>
      {!_.isEmpty(_.get(data, 'linkCTA', {})) && (
        <div className="w-full flex justify-center items-center pt-[50px]">
          <Link
            href={_.get(data, 'linkCTA.url')}
            target="_blank"
            className="value-added-services-cta w-fit flex 
            justify-center items-center rounded-[4px]
            ltr:font-URWDINRegular rtl:font-GESSTwoDWTCMedium gap-[10px] 
            ltr:leading-1 rtl:leading-1.3 
            h-[77px] rtl:text-[15px] ltr:text-[18px] md:rtl:text-[18px] md:ltr:text-[20px] 
            lg:rtl:text-[23px] lg:ltr:text-[25px]
            hover:bg-[#B53B50] pt-1 md:pt-[6px]
            px-12 md:px-14 bg-[#CE445B] text-white">
            <div
              className="[&>*]:text-white [&>*]:m-0 [&>p>strong]:!font-URWDINBold
              p-child:!font-GESSTwoDWTCMedium"
              dangerouslySetInnerHTML={{ __html: _.get(data, 'ctaLabel', '') }}
            />
            <Sprites name="arrow-rounded-next" className="rtl:scale-[-1]"/>
          </Link>
        </div>
      )}
    </section>
  );
}

export default FreeZoneHubServices;
